'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import { use } from 'react';
import useSWR from 'swr';
import NewPremiumReleasesSection from '@/app/[locale]/(worlds)/(worlds-landing)/new/components/NewPremiumReleasesSection';
import { SwimlaneSkeleton } from '@/app/[locale]/(worlds)/components/Swimlane';
import PremiumBadge from '@/components/PremiumBadge';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useUAContext } from '@/context/UAContext';
import { filterPremiumWorlds } from '@/lib/cms';
import { EditorChoiceCards, getEditorChoices } from '@/services/cms';
type NewPremiumReleasesProps = {
  premiumWorldsPromise: Promise<EditorChoiceCards>;
};
export default function NewPremiumReleases(t0) {
  const $ = _c(14);
  const {
    premiumWorldsPromise
  } = t0;
  const t = useTranslations();
  const premiumWorlds = use(premiumWorldsPromise);
  const locale = useLocale();
  const {
    totalVramKb
  } = useUAContext();
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  let t1;
  if ($[0] !== htcToken || $[1] !== locale || $[2] !== totalVramKb) {
    t1 = () => getEditorChoices(undefined, undefined, "new", locale, totalVramKb, false, htcToken).then(_temp);
    $[0] = htcToken;
    $[1] = locale;
    $[2] = totalVramKb;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== premiumWorlds) {
    t2 = {
      fallbackData: premiumWorlds,
      revalidateOnMount: false
    };
    $[4] = premiumWorlds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: t3
  } = useSWR(htcToken ? "premiumWorlds" : null, t1, t2);
  const data = t3 === undefined ? premiumWorlds : t3;
  if (!data.rooms || data.rooms.length === 0) {
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PremiumBadge />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("worlds-landing.new.new-premium-releases.title");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="flex items-center gap-3">{t4}{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data || $[12] !== t6) {
    t7 = <NewPremiumReleasesSection title={t6} worlds={data} />;
    $[11] = data;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(res) {
  const editorChoices = res?.results?.results || [];
  return filterPremiumWorlds(Promise.resolve(editorChoices));
}
export function NewPremiumReleasesSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SwimlaneSkeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}